
import React, { useEffect, useState } from "react";
import Branches from "../../Api/Branches";

function ModelValidityExtend(props) {
    const [ExpiryDate, setExpiryDate] = useState();
    const [ServiceExpiryDate, setServiceExpiryDate] = useState();

    useEffect(() => {
        console.log("props.clientData", props.clientData.ExpiryDate);
        console.log("props.clientData", props.clientData.ServiceExpiryDate);
    }, [props.clientData]);

    const convertToGMT530 = (utcTime) => {
        const utcDate = new Date(utcTime);
        // GMT+5:30 is 5 hours and 30 minutes ahead of UTC
        const gmt530Offset = utcDate.getTime() + (5 * 60 * 60 * 1000) + (30 * 60 * 1000);
        const gmt530Date = new Date(gmt530Offset);

        // Format it as YYYY-MM-DD
        return gmt530Date.toISOString().split('T')[0];
    };

    useEffect(() => {
        if (props.clientData) {

            if (props.clientData.ExpiryDate) {
                const formattedDate = convertToGMT530(props.clientData.ExpiryDate);
                setExpiryDate(formattedDate);
            }

            if (props.clientData.ServiceExpiryDate) {
                const formattedServiceDate = convertToGMT530(props.clientData.ServiceExpiryDate);
                setServiceExpiryDate(formattedServiceDate);
            }
        }
    }, [props.clientData]);

    const handleServiceExpiryDateSave = async () => {
        const id = props.clientData ? props.clientData.id : null;
        try {
            const data = {
                ExpiryDate: ExpiryDate
            };
            const response = await Branches.UpdateBranch(id, data);
            if (response) {
                console.log("response", response);
            }

            const data1 = {
                ServiceExpiryDate: ServiceExpiryDate
            };
            const response1 = await Branches.UpdateBranch(id, data1);
            if (response1) {
                console.log("response", response1);
            }
            const data2 = {
                
            }

            if (props.onSaveSuccess) {
                await props.onSaveSuccess();
            }
        } catch (error) {
            console.error(error);
        }
    };


    return (
        <div>
            <div className="">
                <div className="company_control">
                    <div className="stock-im-dep1">
                        <div className="input-box-Imo1 input-height2">
                            <div className="input-box-mok1">
                                <input className="modify_im_input mode_category1"
                                    type="date"
                                    value={ExpiryDate}
                                    onChange={(e) => setExpiryDate(e.target.value)}
                                    required />
                                <label class="modify_lbl_text3">Expiry Date</label>
                            </div>
                        </div>
                    </div>
                    <div className="stock-im-dep1">
                        <div className="input-box-Imo1 input-height2">
                            <div className="input-box-mok1">
                                <input className="modify_im_input mode_category1"
                                    type="date"
                                    onChange={(e) => setServiceExpiryDate(e.target.value)}
                                    value={ServiceExpiryDate}
                                    required />
                                <label class="modify_lbl_text3">Service Expiry Date</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ direction: "rtl" }}>
                    <button onClick={handleServiceExpiryDateSave} className="temp-save">Save</button>
                </div>
                {/* <div className="Save-flex-btn">
                    <button className="temp-save">Save</button>
                    <button className="temp-save">Update</button>
                </div> */}
            </div>
        </div >
    );
}


export default ModelValidityExtend;
